import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const SchemeDashboard = lazy(() => import("./SchemeDashboard"));

const SCHEMEDASH_ROUTES: RouteObject[] = [
  {
    path: "/private/schemes",
    element: React.createElement(SchemeDashboard),
  },
];

export default SCHEMEDASH_ROUTES;
